{
  "generic": {
    "no": "Nein",
    "yes": "Ja",
    "text": "Text "
  },
  "consent": {
    "defaultLabelText": "Indem Sie dieses Formular absenden, stimmen Sie unserer ",
    "defaultLabelLink": "datenschutzrichtlinie"
  },
  "text": {
    "defaultHeadlineText": "Dies ist eine Überschrift",
    "defaultText": "Dies ist ein Textblock",
    "floatingDefaultText": "NEU!"
  },
  "button": {
    "submitDefaultText": "Absenden",
    "instagramDefaultText": "Folgen Sie uns",
    "defaultText": "Hier klicken",
    "closing": "SCHLIESSEN..."
  },
  "input": {
    "emailLabel": "E-Mail",
    "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
    "passwordLabel": "Passwort",
    "passwordPlaceholder": "Passwort eingeben",
    "nameLabel": "Name",
    "namePlaceholder": "Geben Sie Ihren Namen ein",
    "firstNameLabel": "Vorname",
    "firstNamePlaceholder": "Vorname eingeben",
    "lastNameLabel": "Nachname",
    "lastNamePlaceholder": "Nachname eingeben",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Telefonnummer eingeben",
    "textareaLabel": "Nachricht",
    "textareaPlaceholder": "Geben Sie Ihre Nachricht ein",
    "regularLabel": "Text",
    "regularPlaceholder": "Text eingeben",
    "defaultLabel": "Bezeichnung",
    "defaultPlaceholder": "Platzhalter",
    "datePlaceholder": "Datum auswählen",
    "stepLabel": "Geben Sie hier Ihre Frage ein"
  },
  "dropdown": {
    "placeholder": "Wählen Sie eine Option",
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "chooseCountry": "Land"
  },
  "buttonList": {
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "option1": "Auswahl 1",
    "option2": "Auswahl 2",
    "option3": "Auswahl 3",
    "subscriptionItem1": "Newsletter",
    "subscriptionItem2": "Aktualisierungen",
    "chooseSubscriptionTopics": "Abonnementthemen wählen",
    "other": "Andere",
    "uncheck-all-label": "Ich möchte keine dieser E-Mails erhalten"
  },
  "rating": {
    "rateLabel": "Bewerten Sie uns",
    "npsLabel": "Wie wahrscheinlich ist es, dass Sie uns weiterempfehlen?",
    "veryUnsatisfied": "Sehr unzufrieden",
    "unsatisfied": "Unzufrieden",
    "neutral": "Neutral",
    "satisfied": "Zufrieden",
    "loveIt": "Liebe es!",
    "minValueLabel": "Niedrig",
    "maxValueLabel": "Hoch",
    "minValueLabelNps": "Nicht wahrscheinlich",
    "maxValueLabelNps": "Sehr wahrscheinlich"
  },
  "deadline": {
    "days": "Tage",
    "hours": "Stunden",
    "minutes": "Minuten",
    "seconds": "Sekunden"
  },
  "bulletList": {
    "firstItem": "Vorteil 1",
    "secondItem": "Vorteil 2"
  },
  "discountCode": {
    "copyMessage": "In die Zwischenablage kopiert!",
    "fallback": "WELCOME10",
    "textDefault": "Ihr Rabattcode",
    "buttonDefault": "Kopieren"
  },
  "share": {
    "buttonText": "Teilen"
  },
  "common": {
    "label": "Bezeichnung"
  },
  "wcag": {
    "banner": "Werbebanner",
    "closeButton": "Schließen",
    "submitButton": "Formular absenden"
  },
  "spinTheWheel": {
    "prizeWonText": "Glückwunsch!",
    "prizeWonButtonText": "Holen Sie sich Ihren Preis",
    "prizeLostText": "Ohhh, schade! :-(",
    "prizeLostButtonText": "Zum Schließen klicken",
    "spinButtonLabel": "DREHEN"
  },
  "memory": {
    "resultWonText": "Gut gemacht! Ihre Zeit war {elapsedTime}",
    "resultWonButtonText": "Holen Sie sich Ihren Preis"
  },
  "stepNavigation": {
    "nextButtonText": "Weiter",
    "previousButtonText": "Zurück",
    "lastButtonText": "Schließen",
    "submitButtonText": "Absenden"
  },
  "defaultRealTimeMessage": {
    "validationError": "Bitte überprüfen Sie das Format der gesendeten Daten.",
    "unknownError": "Beim Absenden ist ein unerwartetes Problem aufgetreten.",
    "conflictError": "Dieser Benutzer existiert bereits.",
    "success": "Formular gesendet."
  }
}
